export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表单提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '邮箱',
  'pages.template.form.department': '部门',
  'pages.template.form.joinDate': '入职日期',
  'pages.template.form.remarks': '备注',
  'pages.template.placeholder.name': '请输入姓名',
  'pages.template.placeholder.email': '请输入邮箱',
  'pages.template.placeholder.department': '请选择部门',
  'pages.template.placeholder.remarks': '请输入备注信息',
  'pages.template.validation.nameRequired': '请输入姓名',
  'pages.template.validation.emailRequired': '请输入邮箱',
  'pages.template.validation.emailInvalid': '邮箱格式不正确',
  'pages.template.validation.departmentRequired': '请选择部门',
  'pages.template.validation.joinDateRequired': '请选择入职日期',
  'pages.template.department.tech': '技术部',
  'pages.template.department.sales': '销售部',
  'pages.template.department.hr': '人力资源部',
  'pages.template.department.finance': '财务部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',

  // 项目管理
  'pages.projects.column.name': '名称',
  'pages.projects.column.description': '描述',
  'pages.projects.column.appCount': '应用数',
  'pages.projects.column.memberCount': '成员数',
  'pages.projects.column.createdAt': '创建时间',
  'pages.projects.column.updatedAt': '最近活跃',
  'pages.projects.column.action': '操作',
  'pages.projects.column.health': '健康状态',
  'pages.projects.action.detail': '详情',
  'pages.projects.action.cancel': '取消',
  'pages.projects.action.save': '保存',
  'pages.projects.action.delete': '删除',
  'pages.projects.action.remove': '移除',
  'pages.projects.action.copy': '复制',
  'pages.projects.action.copied': '复制成功',
  'pages.projects.form.name': '名称',
  'pages.projects.form.name.placeholder': '请输入项目名称',
  'pages.projects.form.description': '描述',
  'pages.projects.form.description.placeholder': '请输入项目背景或业务说明',
  'pages.projects.create.title': '创建项目',
  'pages.projects.create.success': '项目创建成功',
  'pages.projects.delete.confirm':
    '确认删除该项目吗？包含的所有应用和资源将同步销毁！',
  'pages.projects.delete.success': '项目已删除',

  // 统计概览 Banner
  'pages.projects.stats.totalProjects': '项目总数',
  'pages.projects.stats.runningApps': '运行中应用',
  'pages.projects.stats.databases': '数据库/中间件',
  'pages.projects.stats.storage': '对象存储桶',
  'pages.projects.stats.cpuAllocation': 'CPU 配额占用',
  'pages.projects.stats.memoryAllocation': '内存配额占用',
  'pages.projects.stats.healthRate': '健康运行率',
  'pages.projects.view.card': '卡片视图',
  'pages.projects.view.table': '表格视图',

  // 筛选与排序
  'pages.projects.filter.all': '全部项目',
  'pages.projects.filter.running': '正常运行',
  'pages.projects.filter.production': '生产环境',
  'pages.projects.filter.agent': 'AI 智能体',
  'pages.projects.filter.warning': '告警 / 异常',
  'pages.projects.filter.managed': '我管理的',
  'pages.projects.sort.recent': '按最近活跃',
  'pages.projects.sort.created': '按创建时间',
  'pages.projects.sort.apps': '按应用数量',
  'pages.projects.sort.quota': '按算力占用',
  'pages.projects.sort.name': '按名称字母',

  // 卡片
  'pages.projects.card.enter': '进入工作台',
  'pages.projects.card.running': '运行中',
  'pages.projects.card.quota': '资源利用',
  'pages.projects.card.quickAction': '快捷操作',
  'pages.projects.card.createApp': '新建应用',
  'pages.projects.card.pin': '置顶项目',
  'pages.projects.card.unpin': '取消置顶',

  // Tab
  'pages.projects.tab.overview': '概览',
  'pages.projects.tab.market': '应用市场',
  'pages.projects.tab.apps': '应用',
  'pages.projects.tab.databases': '数据库',
  'pages.projects.tab.storage': '存储',
  'pages.projects.tab.members': '成员',
  'pages.projects.tab.auditLog': '审计日志',

  // 概览
  'pages.projects.overview.healthDistribution': '应用健康度分布',
  'pages.projects.overview.resourceQuota': '项目资源配额使用率',
  'pages.projects.overview.resourceUsage': '资源利用率看板',
  'pages.projects.overview.field.runningApps': '运行中应用',
  'pages.projects.overview.cpuUsed': 'CPU 配额',
  'pages.projects.overview.memoryUsed': '内存配额',
  'pages.projects.overview.storageUsed': '存储空间',
  'pages.projects.overview.quickEntry': '常用快捷入口',
  'pages.projects.overview.quickEntry.appList': '应用列表',
  'pages.projects.overview.quickEntry.market': '从模板市场安装',
  'pages.projects.overview.quickEntry.inviteMember': '邀请成员',
  'pages.projects.overview.serviceHealthRate': '服务健康率',
  'pages.projects.overview.cpuQuota': 'CPU 算力配额',
  'pages.projects.overview.recentActivity': '近期操作动态',
  'pages.projects.overview.noActivity': '暂无最近操作记录',

  // 市场
  'pages.projects.market.title': '应用与中间件市场',
  'pages.projects.market.subtitle': '开箱即用的第一方套件与标准中间件',
  'pages.projects.market.category.all': '全部模板',
  'pages.projects.market.category.workvista': 'WorkVista 官方套件',
  'pages.projects.market.category.middleware': '数据与中间件',
  'pages.projects.market.installAction': '一键安装到项目',
  'pages.projects.market.installModalTitle': '安装应用模板: {name}',
  'pages.projects.market.installSuccess': '模板已成功实例化并部署到当前项目',

  // 数据库
  'pages.projects.databases.title': '数据库与数据存储实例',
  'pages.projects.databases.create': '新建数据库实例',
  'pages.projects.databases.column.name': '实例名称',
  'pages.projects.databases.column.engine': '引擎与版本',
  'pages.projects.databases.column.status': '状态',
  'pages.projects.databases.column.host': '连接端点',
  'pages.projects.databases.column.storage': '存储使用率',
  'pages.projects.databases.connString': '连接字符串',
  'pages.projects.databases.action.restart': '重启实例',
  'pages.projects.databases.action.stop': '停止实例',
  'pages.projects.databases.createSuccess': '数据库实例创建成功',
  'pages.projects.databases.actionSuccess': '数据库操作已下发',

  // 存储
  'pages.projects.storage.title': '对象存储 (S3 兼容)',
  'pages.projects.storage.create': '新建存储桶',
  'pages.projects.storage.column.bucket': '存储桶名称',
  'pages.projects.storage.column.endpoint': 'S3 Endpoint',
  'pages.projects.storage.column.quota': '已用空间 / 配额',
  'pages.projects.storage.column.files': '对象数',
  'pages.projects.storage.column.acl': '访问控制',
  'pages.projects.storage.column.keys': '访问凭证 (AK/SK)',
  'pages.projects.storage.createSuccess': '存储桶创建成功',
  'pages.projects.storage.fileList': '文件预览',

  // 应用
  'pages.projects.app.column.status': '状态',
  'pages.projects.app.column.category': '类型',
  'pages.projects.app.column.repoUrl': '代码仓库',
  'pages.projects.app.column.version': '运行版本',
  'pages.projects.app.column.endpoints': '访问地址',
  'pages.projects.app.create.title': '创建应用',
  'pages.projects.app.create.success': '应用创建成功',
  'pages.projects.app.form.name.placeholder': '请输入应用名称',
  'pages.projects.app.form.category': '应用类型',
  'pages.projects.app.form.repoMode': '代码仓库来源',
  'pages.projects.app.form.repoMode.create': '自动创建代码仓库',
  'pages.projects.app.form.repoMode.bind': '绑定已有代码仓库',
  'pages.projects.app.form.repoMode.create.hint':
    '将按珊瑚虫应用标准自动创建代码仓库，无需手动填写地址',
  'pages.projects.app.form.repoUrl': '代码仓库地址',
  'pages.projects.app.form.repoUrl.invalid': '请输入合法的 Git 仓库地址',
  'pages.projects.app.overview': '应用概览',
  'pages.projects.appStatus.draft': '待部署',
  'pages.projects.appStatus.deploying': '部署中',
  'pages.projects.appStatus.running': '运行中',
  'pages.projects.appStatus.stopped': '已停止',
  'pages.projects.appStatus.failed': '异常',

  // 应用详情 Tab 与控制台
  'pages.projects.app.tab.overview': '概览与 Pod 拓扑',
  'pages.projects.app.tab.logs': '实时容器日志',
  'pages.projects.app.tab.deploy': '部署配置',
  'pages.projects.app.tab.history': '版本发布与回滚',
  'pages.projects.app.pod.title': 'Pod 实例健康度与资源利用',
  'pages.projects.app.pod.name': 'Pod 名称',
  'pages.projects.app.pod.node': '运行节点',
  'pages.projects.app.pod.ip': 'Pod IP',
  'pages.projects.app.pod.restarts': '重启次数',
  'pages.projects.app.pod.cpu': 'CPU 占用',
  'pages.projects.app.pod.memory': '内存占用',
  'pages.projects.app.logs.autoScroll': '自动滚屏',
  'pages.projects.app.logs.clear': '清空输出',
  'pages.projects.app.logs.download': '下载日志',
  'pages.projects.app.logs.search': '搜索日志关键字...',
  'pages.projects.app.history.version': '版本号',
  'pages.projects.app.history.commit': 'Git 提交',
  'pages.projects.app.history.operator': '部署人',
  'pages.projects.app.history.time': '部署时间',
  'pages.projects.app.history.rollback': '一键回滚到该版本',
  'pages.projects.app.history.rollbackConfirm':
    '确认回滚到版本 {version} 吗？当前应用将重新编排容器镜像。',
  'pages.projects.app.history.rollbackSuccess': '已成功触发回滚',

  'pages.projects.app.column.branch': '代码分支',
  'pages.projects.app.column.image': '容器镜像地址',
  'pages.projects.app.column.imagePrefix': '镜像: {image}',
  'pages.projects.app.column.repoOrImage': '源码 / 镜像',
  'pages.projects.app.form.description': '应用描述',
  'pages.projects.app.list.category.all': '全部',
  'pages.projects.app.list.healthRate': '服务健康率',
  'pages.projects.app.repoMode.image': '容器镜像部署',
  'pages.projects.appCategory.agent': 'AI Agent',
  'pages.projects.appCategory.backend': '后端服务',
  'pages.projects.appCategory.frontend': 'Web 前端',
  'pages.projects.appCategory.fullstack': '全栈应用',

  'pages.projects.app.wizard.title.template': '新建应用 / 开发环境',
  'pages.projects.app.wizard.title.config': '配置与启动应用',
  'pages.projects.app.wizard.step1':
    '第 1 步：选择开箱即用的开发模板或自定义镜像',
  'pages.projects.app.wizard.step2': '第 2 步：配置应用参数与代码存储模式',
  'pages.projects.app.wizard.createSuccess':
    '应用「{name}」创建成功！已拉起云端实例',
  'pages.projects.app.wizard.customImage': '从空白应用 / 自定义容器镜像创建',
  'pages.projects.app.wizard.emptyCategory': '暂无匹配的开发模板',
  'pages.projects.app.wizard.loadFailed': '模板加载失败，请重试',
  'pages.projects.app.wizard.search.placeholder':
    '搜索开发模板、语言、框架或技术栈...',
  'pages.projects.app.wizard.category.all': '全部模板',
  'pages.projects.app.wizard.category.official': '官方脚手架',
  'pages.projects.app.wizard.category.featured': '官方精选',
  'pages.projects.app.wizard.category.frontend': '前端 / 全栈',
  'pages.projects.app.wizard.category.backend': '后端 / 微服务',
  'pages.projects.app.wizard.category.language': '语言环境',
  'pages.projects.app.wizard.category.framework': '应用框架',
  'pages.projects.app.wizard.category.ai': 'AI & 数据',
  'pages.projects.app.wizard.hero.tip':
    '选择开箱即用的开发脚手架快速初始化 Git 仓库与 CI/CD 流水线，或使用自定义容器镜像直接部署。',
  'pages.projects.app.wizard.featuredSection': '官方精选推荐',
  'pages.projects.app.wizard.allSection': '模板资产库',
  'pages.projects.app.wizard.customImageCard.title': '自定义容器镜像部署',
  'pages.projects.app.wizard.customImageCard.desc':
    '从 Harbor、Docker Hub 或私有 Registry 拉取已有容器镜像直接部署，无需初始化代码脚手架。',
  'pages.projects.app.wizard.customImageCard.badge': '纯镜像 / 无 Git 依赖',
  'pages.projects.app.wizard.customImageCard.action': '直接配置镜像',
  'pages.projects.app.wizard.card.author': 'By: {author}',
  'pages.projects.app.wizard.card.use': '选用此模板',
  'pages.projects.app.wizard.card.details': '架构详情',
  'pages.projects.app.wizard.card.featuredBadge': '精选',
  'pages.projects.app.wizard.card.officialBadge': '官方认证',
  'pages.projects.app.wizard.card.specs': '默认规格',
  'pages.projects.app.wizard.card.port': '端口',
  'pages.projects.app.wizard.filter.allTags': '全部技术栈',
  'pages.projects.app.wizard.filter.reset': '重置筛选条件',
  'pages.projects.app.wizard.drawer.title': '模板架构详情与配置规范',
  'pages.projects.app.wizard.drawer.scaffoldFeatures': '开箱即用特性',
  'pages.projects.app.wizard.drawer.versions': '版本与镜像矩阵',
  'pages.projects.app.wizard.drawer.defaultResources': '基准资源配置',
  'pages.projects.app.wizard.drawer.gitScaffold': '代码仓库初始化策略',
  'pages.projects.app.wizard.drawer.useThis': '选用此模板并配置应用',
  'pages.projects.app.wizard.empty.tip':
    '没有找到匹配的开发模板，您可以尝试更换关键词，或直接使用自定义容器镜像部署。',

  'pages.projects.app.wizard.sourceMode.createGit.title':
    '自动创建托管 Git 仓库',
  'pages.projects.app.wizard.sourceMode.createGit.badge': '推荐 / 自动初始化',
  'pages.projects.app.wizard.sourceMode.createGit.desc':
    '在珊瑚云内置 Git 服务中自动初始化代码仓库，注入所选模板脚手架并自动关联 CI/CD 构建流水线。',
  'pages.projects.app.wizard.sourceMode.bindGit.title': '绑定已有 Git 仓库',
  'pages.projects.app.wizard.sourceMode.bindGit.badge': '外部代码库',
  'pages.projects.app.wizard.sourceMode.bindGit.desc':
    '关联已有 GitHub / GitLab / Gitee 仓库地址与分支，每次代码 Push 自动触发编译与滚动发布。',
  'pages.projects.app.wizard.sourceMode.image.title':
    '容器镜像直接部署 (无需 Git)',
  'pages.projects.app.wizard.sourceMode.image.badge': '纯镜像 / 无 Git 依赖',
  'pages.projects.app.wizard.sourceMode.image.desc':
    '直接通过 Docker 镜像 (如官方镜像或私有 Registry 产物) 启动实例，完全无需创建或绑定 Git 仓库。',

  'pages.projects.app.wizard.config.customImageApp': '自定义容器镜像应用',
  'pages.projects.app.wizard.config.customImageDesc':
    '直接指定任意 Docker 镜像运行并挂载存储与网络',
  'pages.projects.app.wizard.config.changeTemplate': '更换模板',
  'pages.projects.app.wizard.config.basicInfo': '基本信息',
  'pages.projects.app.wizard.config.name.required': '请输入应用名称',
  'pages.projects.app.wizard.config.name.pattern':
    '仅支持小写字母、数字与中划线',
  'pages.projects.app.wizard.config.name.maxLength': '不能超过50个字符',
  'pages.projects.app.wizard.config.name.extra':
    '作为服务名与 DNS 前缀，创建后不支持修改',
  'pages.projects.app.wizard.config.name.placeholder': '例如: my-node-service',
  'pages.projects.app.wizard.config.description.placeholder':
    '简要说明此应用的用途与业务场景',
  'pages.projects.app.wizard.config.category.required': '请选择应用分类',
  'pages.projects.app.wizard.config.sourceStrategy': '代码与构建策略',
  'pages.projects.app.wizard.config.sourceStrategy.hint':
    '支持平台自动创建仓库、绑定已有 Git 或纯镜像直跑',
  'pages.projects.app.wizard.config.repoName': '托管仓库名称',
  'pages.projects.app.wizard.config.repoName.extra':
    '系统将在内置 Git 服务中自动初始化该代码仓库并推送模板脚手架与 CI/CD 流水线',
  'pages.projects.app.wizard.config.repoUrl.required':
    '请输入已有的 Git 仓库地址',
  'pages.projects.app.wizard.config.branch': '部署分支',
  'pages.projects.app.wizard.config.image': '容器镜像地址 (Image:Tag)',
  'pages.projects.app.wizard.config.image.required': '请输入容器镜像地址',
  'pages.projects.app.wizard.config.image.extra':
    '直接拉取已有容器镜像启动服务，完全不需要创建或关联任何 Git 仓库',
  'pages.projects.app.wizard.config.runtime': '运行时与网络配置',
  'pages.projects.app.wizard.config.cpu': 'CPU 配额',
  'pages.projects.app.wizard.config.memory': '内存配额',
  'pages.projects.app.wizard.config.port': '服务端口',
  'pages.projects.app.wizard.config.port.required': '请填写端口',
  'pages.projects.app.wizard.config.publicDomain': '公网访问路由',
  'pages.projects.app.wizard.config.on': '开启',
  'pages.projects.app.wizard.config.off': '关闭',
  'pages.projects.app.wizard.config.domainPreview': '公网访问域名预览：',
  'pages.projects.app.wizard.config.advanced': '高级选项 (环境变量 & 启动参数)',
  'pages.projects.app.wizard.config.customCommand':
    '自定义启动命令 (Command & Args)',
  'pages.projects.app.wizard.config.customCommand.extra':
    '若留空则使用模板镜像默认的 Entrypoint',
  'pages.projects.app.wizard.config.storage': '持久卷存储容量 (GB)',
  'pages.projects.app.wizard.config.storage.extra':
    '将持久化挂载到应用的 /data 目录',
  'pages.projects.app.wizard.config.backToTemplate': '返回模板选择',
  'pages.projects.app.wizard.config.submit': '立即创建并运行',
  'pages.projects.app.wizard.config.descriptionFromTemplate':
    '基于 {name} ({version}) 开发模板构建',

  // 成员
  'pages.projects.member.column.name': '姓名',
  'pages.projects.member.column.email': '邮箱',
  'pages.projects.member.column.role': '角色',
  'pages.projects.member.column.joinedAt': '加入时间',
  'pages.projects.member.add.title': '添加成员',
  'pages.projects.member.add.success': '成员添加成功',
  'pages.projects.member.form.selectCandidate': '从组织/租户成员中选取',
  'pages.projects.member.form.selectCandidate.placeholder':
    '搜索姓名、用户名或邮箱快速选择',
  'pages.projects.member.form.member': '成员标识',
  'pages.projects.member.form.member.required': '请输入或选择成员标识/UUID',
  'pages.projects.member.form.member.placeholder':
    '请输入成员 memberUuid / 姓名',
  'pages.projects.member.form.name': '成员姓名',
  'pages.projects.member.form.name.placeholder':
    '例如：张三（选填，默认自动从身份库同步）',
  'pages.projects.member.form.email': '成员邮箱',
  'pages.projects.member.form.email.placeholder':
    '例如：zhangsan@company.com（选填）',
  'pages.projects.member.form.role': '项目角色',
  'pages.projects.member.role.admin': '项目管理员',
  'pages.projects.member.role.member': '项目成员',
  'pages.projects.member.remove.confirm': '确认移除该成员吗？',
  'pages.projects.member.remove.success': '成员已移除',
  'pages.projects.member.permission': '应用细粒度权限',
  'pages.projects.permission.title': '{name} 的应用权限矩阵',
  'pages.projects.permission.column.app': '应用名称',
  'pages.projects.permission.column.visible': '可见 (Visible)',
  'pages.projects.permission.column.deploy': '可部署 (Deploy)',
  'pages.projects.permission.column.manage': '可管理 (Manage)',
  'pages.projects.permission.save.success': '权限已保存',
  'pages.projects.permission.quickPreset': '快捷预设: ',
  'pages.projects.permission.presetViewer': '全部只读',
  'pages.projects.permission.presetDeveloper': '全部开发者',
  'pages.projects.permission.presetAdmin': '全部管理员',

  // 审计日志
  'pages.projects.audit.noPermission': '仅项目管理员可查看审计日志',
  'pages.projects.audit.column.operator': '操作人',
  'pages.projects.audit.column.action': '操作类型',
  'pages.projects.audit.column.target': '操作对象',
  'pages.projects.audit.column.detail': '详情',
  'pages.projects.audit.column.createdAt': '操作时间',
  'pages.projects.audit.action.projectCreate': '创建项目',
  'pages.projects.audit.action.projectUpdate': '更新项目',
  'pages.projects.audit.action.projectDelete': '删除项目',
  'pages.projects.audit.action.appCreate': '创建应用',
  'pages.projects.audit.action.appDeploy': '发布部署',
  'pages.projects.audit.action.appLifecycle': '状态变更',
  'pages.projects.audit.action.appDelete': '删除应用',
  'pages.projects.audit.action.memberAdd': '添加成员',
  'pages.projects.audit.action.memberRemove': '移除成员',
  'pages.projects.audit.action.memberPermissionsUpdate': '权限配置',
  'pages.projects.audit.action.databaseCreate': '创建数据库',
  'pages.projects.audit.action.databaseAction': '数据库操作',
  'pages.projects.audit.action.marketInstall': '安装市场模板',

  // 部署配置
  'pages.projects.deploy.title': '部署配置',
  'pages.projects.deploy.noPermission': '仅项目管理员可配置部署',
  'pages.projects.deploy.source': '部署来源',
  'pages.projects.deploy.source.image': '镜像部署',
  'pages.projects.deploy.source.repoBuild': '代码仓库构建',
  'pages.projects.deploy.branch': '构建分支',
  'pages.projects.deploy.image': '镜像地址',
  'pages.projects.deploy.resource': '资源规格',
  'pages.projects.deploy.cpu': 'CPU',
  'pages.projects.deploy.memory': '内存',
  'pages.projects.deploy.replicas': '副本数',
  'pages.projects.deploy.network': '网络配置',
  'pages.projects.deploy.port': '容器端口',
  'pages.projects.deploy.port.exposePublic': '公网访问 (Ingress)',
  'pages.projects.deploy.port.add': '添加端口',
  'pages.projects.deploy.envVars': '环境变量与 Secret',
  'pages.projects.deploy.envVars.add': '添加环境变量',
  'pages.projects.deploy.storage': '存储卷挂载',
  'pages.projects.deploy.storage.add': '添加存储卷',
  'pages.projects.deploy.healthCheck': '健康检查探针',
  'pages.projects.deploy.healthCheck.enable': '启用健康检查',
  'pages.projects.deploy.healthCheck.path': '检查路径',
  'pages.projects.deploy.healthCheck.port': '检查端口',
  'pages.projects.deploy.submit': '保存并立即发布',
  'pages.projects.deploy.success': '部署已提交',

  // 生命周期
  'pages.projects.lifecycle.start': '启动',
  'pages.projects.lifecycle.stop': '停止',
  'pages.projects.lifecycle.stop.confirm': '确认停止该应用吗？',
  'pages.projects.lifecycle.restart': '重启',
  'pages.projects.lifecycle.rollback': '回滚',
  'pages.projects.lifecycle.rollback.placeholder': '请选择回滚的历史版本',
  'pages.projects.lifecycle.delete': '删除',
  'pages.projects.lifecycle.delete.confirm': '确认删除该应用吗？此操作不可恢复',
  'pages.projects.lifecycle.success': '操作已提交',

  // 项目设置与配额
  'pages.projects.settings.basicInfo': '项目空间基本信息',
  'pages.projects.settings.saveChanges': '保存修改',
  'pages.projects.settings.saveSuccess': '项目空间基本信息更新成功',
  'pages.projects.settings.quotaSuccess':
    '配额扩容申请已提交（CPU: {cpu} Core, 内存: {memory} GiB），已自动生效',
  'pages.projects.settings.field.uuid': '项目空间唯一标识 (UUID / Namespace)',
  'pages.projects.settings.quotaManagement': '算力与资源配额管理',
  'pages.projects.settings.applyQuota': '申请扩容配额',
  'pages.projects.settings.quotaProtectionTitle': '配额保护机制已启用',
  'pages.projects.settings.quotaProtectionDesc':
    '当空间下所有运行中的微服务与 AI Agent 的 CPU/内存总和触达配额上限时，新应用部署将被安全拦截，防止集群节点因超售引发 OOM。',
  'pages.projects.settings.cpuLimit': 'CPU 算力硬限制 (Core)',
  'pages.projects.settings.allocatedUsage': '已分配利用率: {used} Core',
  'pages.projects.settings.memoryLimit': '内存容量上限 (GiB)',
  'pages.projects.settings.allocatedUsageGiB': '已分配利用率: {used} GiB',
  'pages.projects.settings.storageLimit': '持久存储上限 (GiB)',
  'pages.projects.settings.mountedPvc': '已挂载 PVC: {used} GiB',
  'pages.projects.settings.dangerZone': '空间生命周期管理（危险区）',
  'pages.projects.settings.archive.title': '归档此项目空间',
  'pages.projects.settings.archive.hint':
    '冻结运行中的所有实例，停止计算资源计费，数据安全保留',
  'pages.projects.settings.archive.button': '归档空间',
  'pages.projects.settings.archive.confirm': '确认归档该项目空间？',
  'pages.projects.settings.archive.content':
    '归档后，该空间下的所有微服务与 Agent 将进入冻结状态，停止算力计费，配置与持久卷数据将完整保留。',
  'pages.projects.settings.archive.ok': '确认归档',
  'pages.projects.settings.archive.success': '项目空间「{name}」已成功归档',
  'pages.projects.settings.destroy.title': '彻底销毁此项目空间',
  'pages.projects.settings.destroy.hint':
    '移除该项目空间及其关联应用记录，不可恢复；项目与租户内其他项目共享同一 Kubernetes Namespace，不会连带清理该 Namespace',
  'pages.projects.settings.destroy.button': '销毁空间',
  'pages.projects.settings.destroy.confirm': '高危操作：确认销毁该项目空间？',
  'pages.projects.settings.destroy.content':
    '此操作不可逆！销毁后，该空间下的所有容器 Pod、存储卷 PVC 以及团队权限关联将彻底释放。',
  'pages.projects.settings.destroy.ok': '强制销毁',
  'pages.projects.settings.destroy.success': '项目空间「{name}」已彻底销毁释放',
  'pages.projects.settings.expandModal.title': '申请项目算力配额扩容',
  'pages.projects.settings.expandModal.ok': '确认扩容',
  'pages.projects.settings.expandModal.cpu': '目标 CPU 算力上限 (Core)',
  'pages.projects.settings.expandModal.memory': '目标内存上限 (GiB)',
  'pages.projects.settings.expandModal.storage': '目标持久卷存储上限 (GiB)',

  // 平台管理（占位）
  'pages.management.placeholder.fields': '规划中的字段/能力：',
  'pages.management.identities.description':
    '统一管理企业内所有工作主体的身份库，覆盖自然人员工、外部人员、Agent、数字员工、系统账号，项目内添加成员将从这里选取，而不是各项目各自维护一份成员数据。',
  'pages.management.identityType.human': '自然人员工',
  'pages.management.identityType.external': '外部人员',
  'pages.management.identityType.agent': 'Agent',
  'pages.management.identityType.digital': '数字员工',
  'pages.management.identityType.system': '系统账号',
  'pages.management.roles.description':
    '独立于项目之外的全局角色与权限矩阵，按角色定义对应用/数据/接口/Agent 四个维度的访问范围，取代项目内简单的“管理员/成员”两档角色。',
  'pages.management.role.globalAdmin': '全局管理员',
  'pages.management.role.workspaceOwner': '工作空间负责人',
  'pages.management.role.developer': '开发者',
  'pages.management.role.viewer': '只读',
  'pages.management.role.agentCaller': 'Agent 调用者',
  'pages.management.auditLog.description':
    '跨项目的平台级操作审计，可按项目筛选，仅面向具备审计权限的角色开放。与项目详情页内的审计日志是否合并，待后续确定。',
  'pages.management.auditLog.field.operator': '操作人',
  'pages.management.auditLog.field.project': '所属项目',
  'pages.management.auditLog.field.action': '操作类型',
  'pages.management.auditLog.field.result': '执行结果',
  'pages.management.auditLog.field.time': '操作时间',
  'pages.management.clusters.description':
    '面向全局管理员的 Kubernetes 集群与基础设施运维入口，对应“运维与可观测”能力，涵盖节点、资源、健康检查、告警等。',
  'pages.management.clusters.field.nodes': '节点管理',
  'pages.management.clusters.field.resource': '资源监控',
  'pages.management.clusters.field.health': '健康检查',
  'pages.management.clusters.field.alerts': '异常告警',
  'pages.auditLog.title': '全景安全与 AI 审计大盘',
  'pages.auditLog.description':
    '集中记录平台全生命周期的系统关键操作、数据敏感访问，以及 AI Agent 大模型调用与 Token 消耗链条，满足企业级合规与追溯要求。',
  'pages.auditLog.action.refresh': '刷新',
  'pages.auditLog.stats.totalOperations': '今日全局操作',
  'pages.auditLog.stats.sensitiveOperations': '敏感与高危操作',
  'pages.auditLog.stats.aiCalls': 'AI Agent 实时调用',
  'pages.auditLog.stats.totalTokens': '今日 Token 消耗总量',
  'pages.auditLog.stats.timesSuffix': '次',
  'pages.auditLog.stats.tenThousand': '万',
  'pages.auditLog.filter.all': '全部审计',
  'pages.auditLog.filter.operation': '系统操作审计',
  'pages.auditLog.filter.aiCall': 'AI Token 审计',
  'pages.auditLog.filter.dataAccess': '数据访问留痕',
  'pages.auditLog.filter.keywordPlaceholder': '搜索操作人/Agent/动作/目标...',
  'pages.auditLog.filter.search': '查询',
  'pages.auditLog.filter.startDate': '开始时间',
  'pages.auditLog.filter.endDate': '结束时间',
  'pages.auditLog.table.operator': '操作主体',
  'pages.auditLog.table.type': '审计类型',
  'pages.auditLog.table.actionTarget': '动作与目标',
  'pages.auditLog.table.project': '所属项目',
  'pages.auditLog.table.metrics': 'AI / 性能指标',
  'pages.auditLog.table.status': '状态',
  'pages.auditLog.table.time': '操作时间',
  'pages.auditLog.table.detail': '详情',
  'pages.auditLog.table.totalCount': '共 {total} 条记录',
  'pages.auditLog.badge.operation': '系统操作',
  'pages.auditLog.badge.aiCall': 'AI Token 审计',
  'pages.auditLog.badge.dataAccess': '数据访问',
  'pages.auditLog.status.success': '成功',
  'pages.auditLog.status.warning': '告警',
  'pages.auditLog.status.failed': '失败',
  'pages.auditLog.operatorType.agent': '智能体',
  'pages.auditLog.operatorType.system': '系统',
  'pages.auditLog.operatorType.human': '用户',
  'pages.auditLog.drawer.title': '审计日志追踪详情',
  'pages.auditLog.drawer.basicContext': '基础上下文',
  'pages.auditLog.drawer.id': '审计 ID:',
  'pages.auditLog.drawer.operator': '操作主体:',
  'pages.auditLog.drawer.project': '所属项目:',
  'pages.auditLog.drawer.platformGlobal': '平台全局',
  'pages.auditLog.drawer.clientIp': '客户端 IP:',
  'pages.auditLog.drawer.occurredAt': '发生时间:',
  'pages.auditLog.drawer.actionDetail': '操作与详细说明',
  'pages.auditLog.drawer.action': '动作名称:',
  'pages.auditLog.drawer.target': '影响目标:',
  'pages.auditLog.drawer.detail': '执行详情:',
  'pages.auditLog.drawer.aiDetail': 'AI Runtime 调度明细',
  'pages.auditLog.drawer.model': '基座大模型:',
  'pages.auditLog.drawer.promptTokens': 'Prompt Tokens:',
  'pages.auditLog.drawer.completionTokens': 'Completion Tokens:',
  'pages.auditLog.drawer.totalTokens': '总计 Token:',
  'pages.auditLog.drawer.latency': '端到端延迟:',
  'pages.auditLog.metric.prompt': 'Prompt',
  'pages.auditLog.metric.completion': 'Completion',
  'pages.auditLog.metric.latency': '耗时',
  'pages.auditLog.metric.ip': 'IP',
  'pages.platformTenants.title': '租户管理',
  'pages.platformUsers.title': '用户管理',
  'pages.platformUsers.resetPassword': '重置密码',
  'pages.platformUsers.resetPasswordTitle': '重置「{name}」的密码',
  'pages.platformUsers.resetPasswordNotice':
    '重置后旧密码立即失效，请通过安全渠道把新密码告知用户。',
  'pages.platformUsers.newPassword': '新密码',
  'pages.platformUsers.newPasswordRequired': '请输入新密码',
  'pages.platformUsers.newPasswordLength': '密码长度为 6-64 位',
  'pages.platformUsers.generatePassword': '随机生成',
  'pages.platformUsers.copyPassword': '复制密码',
  'pages.platformUsers.passwordCopied': '已复制到剪贴板',
  'pages.platformUsers.passwordCopyFailed': '复制失败，请手动复制',
  'pages.platformUsers.resetPasswordSuccess': '密码已重置',
  'pages.platformUsers.avatar': '头像',
  'pages.platformUsers.avatarUpload': '上传头像',
  'pages.platformUsers.avatarHint': '支持 PNG、JPG、WEBP，不超过 5MB',
  'pages.platformUsers.uploadFailed': '上传失败，请重试',
  'pages.platformUsers.save': '保存',
  'pages.platformUsers.reset': '重置',
  'pages.platformUsers.saveSuccess': '个人资料已保存',
  'pages.platformUsers.website': '个人网站',
  'pages.platformUsers.websiteInvalid': '请输入有效的网址',
  'pages.platformUsers.country': '国家',
  'pages.platformUsers.province': '省份',
  'pages.platformUsers.city': '城市',
  'pages.platformUsers.postalCode': '邮编',
  'pages.platformUsers.identifierClearForbidden':
    '该用户没有用户名，手机号和邮箱不能同时为空，否则将无法登录',
  'pages.platformUsers.usernameImmutableHint': '用户名创建后不可修改',
  'pages.platformUsers.tab.basic': '基本信息',
  'pages.platformUsers.tab.tenants': '所属租户',
  'pages.platformUsers.tab.identities': '第三方账号',
  'pages.platformUsers.tab.loginHistory': '登录日志',
  'pages.platformUsers.userNotFound': '用户不存在或已被删除',
  'pages.platformUsers.sectionAccount': '账号信息',
  'pages.platformUsers.sectionProfile': '个人资料',
  'pages.platformUsers.verified': '已验证',
  'pages.platformUsers.unverified': '未验证',
  'pages.platformUsers.registerSourceLabel': '注册方式',
  'pages.platformUsers.registerSource.adminCreated': '管理员创建',
  'pages.platformUsers.registerSource.basic:phone': '手机号注册',
  'pages.platformUsers.registerSource.basic:email': '邮箱注册',
  'pages.platformUsers.registerSource.basic:username': '用户名注册',
  'pages.platformUsers.signedUp': '注册时间',
  'pages.platformUsers.validity': '账号有效期',
  'pages.platformUsers.perpetual': '永久有效',
  'pages.platformUsers.loginsCount': '登录次数',
  'pages.platformUsers.lastLogin': '最后登录时间',
  'pages.platformUsers.lastIp': '最后登录 IP',
  'pages.platformUsers.genderLabel': '性别',
  'pages.platformUsers.gender.M': '男',
  'pages.platformUsers.gender.F': '女',
  'pages.platformUsers.gender.U': '未知',
  'pages.platformUsers.birthdate': '生日',
  'pages.platformUsers.company': '公司',
  'pages.platformUsers.address': '详细地址',
  'pages.platformUsers.tenantName': '租户名称',
  'pages.platformUsers.tenantCode': '租户编码',
  'pages.platformUsers.departments': '所属部门',
  'pages.platformUsers.departmentPath': '部门路径',
  'pages.platformUsers.noDepartments': '未加入任何部门',
  'pages.platformUsers.noIdentities': '未绑定第三方账号',
  'pages.platformUsers.idpName': '身份源',
  'pages.platformUsers.idpCategory': '身份源类型',
  'pages.platformUsers.idpCategory.enterprise': '企业身份源',
  'pages.platformUsers.idpCategory.social': '社会化身份源',
  'pages.platformUsers.idpDisplayName': '第三方账号名称',
  'pages.platformUsers.idpUserId': '第三方用户标识',
  'pages.platformUsers.bindTime': '绑定时间',
  'pages.platformUsers.noLoginHistory': '暂无登录记录',
  'pages.platformUsers.loginTime': '登录时间',
  'pages.platformUsers.loginApp': '登录应用',
  'pages.platformUsers.loginEvent': '事件',
  'pages.platformUsers.loginResult': '结果',
  'pages.platformUsers.loginIp': 'IP 地址',
  'pages.platformUsers.loginLocation': '登录地点',
  'pages.platformUsers.loginClient': '浏览器 / 系统 / 设备',
  'pages.platformUsers.keywordLabel': '关键词',
  'pages.platformUsers.searchPlaceholder': '搜索用户名、姓名、手机号或邮箱',
  'pages.platformUsers.user': '用户',
  'pages.platformUsers.userId': '用户 ID',
  'pages.platformUsers.username': '用户名',
  'pages.platformUsers.name': '姓名',
  'pages.platformUsers.namePlaceholder': '真实姓名',
  'pages.platformUsers.nickname': '昵称',
  'pages.platformUsers.phone': '手机号',
  'pages.platformUsers.email': '邮箱',
  'pages.platformUsers.password': '初始密码',
  'pages.platformUsers.statusLabel': '状态',
  'pages.platformUsers.status.Activated': '正常',
  'pages.platformUsers.status.Suspended': '已停用',
  'pages.platformUsers.status.Deleted': '已删除',
  'pages.platformUsers.createdAt': '创建时间',
  'pages.platformUsers.updatedAt': '更新时间',
  'pages.platformUsers.actions': '操作',
  'pages.platformUsers.edit': '编辑',
  'pages.platformUsers.enable': '启用',
  'pages.platformUsers.disable': '停用',
  'pages.platformUsers.delete': '删除',
  'pages.platformUsers.createUser': '新建用户',
  'pages.platformUsers.detailTitle': '用户详情',
  'pages.platformUsers.tenants': '所属租户',
  'pages.platformUsers.noTenants': '尚未加入任何租户',
  'pages.platformUsers.usernamePlaceholder': '用于账号密码登录',
  'pages.platformUsers.phonePlaceholder': '用于验证码登录',
  'pages.platformUsers.emailPlaceholder': 'name@example.com',
  'pages.platformUsers.passwordHint':
    '可不填，用户之后可通过验证码登录或重置密码',
  'pages.platformUsers.emailInvalid': '邮箱格式不正确',
  'pages.platformUsers.identifierRequired': '用户名、手机号、邮箱至少填写一项',
  'pages.platformUsers.createSuccess': '用户已创建',
  'pages.platformUsers.enableSuccess': '已启用',
  'pages.platformUsers.disableSuccess': '已停用',
  'pages.platformUsers.deleteSuccess': '用户已删除',
  'pages.platformUsers.enableConfirm': '确定启用该用户？',
  'pages.platformUsers.disableConfirm':
    '停用后该用户将无法登录任何租户，确定停用？',
  'pages.platformUsers.batchEnable': '批量启用',
  'pages.platformUsers.batchDisable': '批量停用',
  'pages.platformUsers.clearSelection': '取消选择',
  'pages.platformUsers.batchEnableConfirm': '确定启用选中的 {count} 个用户？',
  'pages.platformUsers.batchDisableConfirm':
    '停用后这 {count} 个用户将无法登录，确定停用？',
  'pages.platformUsers.deleteConfirmTitle': '确定删除用户「{name}」？',
  'pages.platformUsers.deleteConfirmContent':
    '删除后该账号将从用户池移除，并失去所有租户的成员身份，此操作不可恢复。',
  'pages.platformTenants.searchPlaceholder': '搜索租户名称或 UUID',
  'pages.platformTenants.keywordLabel': '关键词',
  'pages.platformTenants.name': '租户名称',
  'pages.platformTenants.uuid': '租户 UUID',
  'pages.platformTenants.code': '租户编码',
  'pages.platformTenants.memberCount': '成员数量',
  'pages.platformTenants.createdAt': '创建时间',
  'pages.platformTenants.actions': '操作',
  'pages.platformTenants.viewDetail': '查看详情',
  'pages.platformTenants.backToList': '返回租户列表',
  'pages.platformTenants.tabMembers': '成员',
  'pages.platformTenants.tabDepartments': '组织',
  'pages.platformTenants.keywordSearch': '搜索姓名、手机、邮箱或工号',
  'pages.platformTenants.memberName': '姓名',
  'pages.platformTenants.memberPhone': '手机号',
  'pages.platformTenants.memberEmail': '邮箱',
  'pages.platformTenants.memberJobNumber': '工号',
  'pages.platformTenants.memberPosition': '职位',
  'pages.platformTenants.memberStatus': '状态',
  'pages.platformTenants.statusEnabled': '正常',
  'pages.platformTenants.statusDisabled': '禁用',
  'pages.platformTenants.memberRole': '角色身份',
  'pages.platformTenants.admin': '管理员',
  'pages.platformTenants.regularMember': '普通成员',
  'pages.platformTenants.leader': '部门主管',
  'pages.platformTenants.drawerTitle': '成员画像详情',
  'pages.platformTenants.joinedAt': '加入时间',
  'pages.platformTenants.username': '用户名',
  'pages.platformTenants.department': '所属部门',
  'pages.platformTenants.includeChildren': '包含子部门成员',
  'pages.platformTenants.selectDepartmentPrompt': '请选择左侧部门查看成员',
  'pages.platformTenants.noDepartments': '暂无部门数据',
  'pages.platformTenants.totalCount': '共 {total} 项',
  'pages.platformTenants.tabApps': '应用',
  'pages.platformTenants.description': '简介',
  'pages.platformTenants.logo': 'Logo',
  'pages.platformTenants.logoUpload': '上传 Logo',
  'pages.platformTenants.logoHint': '支持 png/jpg/svg/webp，不超过 5MB',
  'pages.platformTenants.nameRequired': '请输入租户名称',
  'pages.platformTenants.saveSuccess': '租户信息已更新',
  'pages.platformTenants.saveFailed': '保存失败，请稍后重试',
  'pages.platformTenants.uploadFailed': 'Logo 上传失败',
  'pages.platformTenants.appName': '应用名称',
  'pages.platformTenants.appId': '应用 ID',
  'pages.platformTenants.installSource': '开通来源',
  'pages.platformTenants.installSourcePackage': '套餐',
  'pages.platformTenants.installSourceTenant': '单独开通',
  'pages.platformTenants.noApps': '该租户暂未开通应用',
  'pages.platformTenants.appsLoadFailed': '应用列表加载失败',
  'pages.platformTenants.tabBasic': '基本信息',
  'pages.platformTenants.save': '保存',
  'pages.platformTenants.reset': '重置',
  'pages.platformTenants.updatedAt': '更新时间',
  'pages.platformTenants.profileCard': '基础资料',
  'pages.platformTenants.infoCard': '租户信息',
  'pages.myTenants.title': '租户设置',
  'pages.myTenants.member': '成员',
  'pages.myTenants.empty': '你还没有加入任何企业',
  'pages.myTenants.selectTenant': '未能确定当前租户，请重新登录',
  'pages.platformTenants.loadCommercialConfigFailed': '加载商业配置失败',
  'pages.platformTenants.loadCommercialStatusFailed': '加载租户商业状态失败',
  'pages.platformTenants.grantSuccess': '授权已生效',
  'pages.platformTenants.grantFailed': '授权失败',
  'pages.platformTenants.subscriptionType': '类型',
  'pages.platformTenants.status': '状态',
  'pages.platformTenants.target': '对象',
  'pages.platformTenants.adminGift': '管理员赠送',
  'pages.platformTenants.startsAt': '开始时间',
  'pages.platformTenants.expiresAt': '过期时间',
  'pages.platformTenants.perpetual': '长期',
  'pages.platformTenants.purchaseParams': '购买参数',
  'pages.platformTenants.orderNo': '订单号',
  'pages.platformTenants.orderDefaultPlan': '系统默认',
  'pages.platformTenants.orderMarketFree': '应用市场免费',
  'pages.platformTenants.appsCount': '{count} 个应用',
  'pages.platformTenants.featureCode': '权益码',
  'pages.platformTenants.featureName': '权益名称',
  'pages.platformTenants.featureType': '类型',
  'pages.platformTenants.finalValue': '最终值',
  'pages.platformTenants.sources': '来源',
  'pages.platformTenants.tenantCommercialStatus': '租户商业状态',
  'pages.platformTenants.adminGrant': '管理员授权',
  'pages.platformTenants.entitlementIntro':
    '这里展示租户最终商业权益，业务系统应该基于权益码鉴权，而不是判断套餐名称。',
  'pages.platformTenants.subscriptions': '订阅',
  'pages.platformTenants.finalEntitlements': '最终权益',
  'pages.platformTenants.tabEntitlements': '权益',
  'pages.platformTenants.tabRoles': '角色',
  'pages.platformTenants.tabAudit': '审计日志',
  'pages.platformTenants.detailTitle': '租户详情',
  'pages.platformTenants.typePlan': '套餐订阅',
  'pages.platformTenants.typeAddon': '加购商品',
  'pages.platformTenants.typeManualGrant': '人工赠送',
  'pages.platformTenants.on': '开启',
  'pages.platformTenants.off': '关闭',
  'pages.platformTenants.seatsUnit': '{count} 席位',
  'pages.platformTenants.quantityUnit': '{count} 份',
  'pages.platformTenants.monthsUnit': '{count} 个月',
  'pages.platformTenants.amountYuan': '{amount} 元',
  'pages.platformTenants.refresh': '刷新',
  'pages.platformTenants.grantType': '授权类型',
  'pages.platformTenants.planVersion': '选择套餐版本',
  'pages.platformTenants.priceItem': '价格项',
  'pages.platformTenants.addonProduct': '加购商品',
  'pages.platformTenants.purchaseQuantity': '购买数量',
  'pages.platformTenants.targetFeature': '目标权益',
  'pages.platformTenants.switchState': '开关状态',
  'pages.platformTenants.numericValue': '数值',
  'pages.platformTenants.applicationCodes': '应用代码列表（每行一个）',
  'pages.platformTenants.seatCount': '席位数',
  'pages.platformTenants.months': '订购月数',
  'pages.platformTenants.paidAmount': '实付金额（元）',
  'pages.myTenants.detailTitle': '租户设置',
};
